import { createEntityAdapter } from '@reduxjs/toolkit'

import { Attribute } from './models/Attribute'

export const attributesAdapter = createEntityAdapter({
  selectId: (attr: Attribute) => attr.id,
})